module.exports = __webpack_public_path__ + "roboto-bold-webfont.8d8c68e3efd2fe4dc040.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-bold-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-bold-webfont.woff2
// module chunks = styles